module.exports = __webpack_public_path__ + "images/common/boutonOmbrePixel.f21d0098.svg";